module.exports = __webpack_public_path__ + "static/media/19ESCAP21.25910c46.jpg";